<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    class="h-[80%]"
  >
    <div class="flex flex-col gap-2 pb-5">
      <div class="relative py-4">
        <div class="text-lg font-bold text-center">选择自设</div>
        <button
          class="btn btn-sm absolute right-3 top-3.5"
          @click="clickCreateSelf"
        >
          新建
        </button>
      </div>

      <div class="flex flex-col gap-2 px-2">
        <h3 class="text-base">我的自设</h3>

        <div class="flex flex-col gap-1">
          <MateTreeholeSelectOrEdit
            :item="mateStore.userMate"
            :active-mate="activeMate"
            @select="clickSelect"
          />
          <MateTreeholeSelectOrEdit
            v-for="item in mateStore.selfAvatarList"
            :key="item.uuid"
            :item="item"
            :active-mate="activeMate"
            @select="clickSelect"
          />
        </div>

        <template v-if="myOriginal.length > 0">
          <h3 class="text-base">我的OC</h3>

          <div class="flex flex-col gap-1">
            <MateTreeholeSelectOrEdit
              v-for="item in myOriginal"
              :key="item.uuid"
              :item="item"
              :active-mate="activeMate"
              @select="clickSelect"
              is-import
            />
          </div>
        </template>

        <template v-if="myFanswork.length > 0">
          <h3 class="text-base">我的二创</h3>

          <div class="flex flex-col gap-1">
            <MateTreeholeSelectOrEdit
              v-for="item in myFanswork"
              :key="item.uuid"
              :item="item"
              :active-mate="activeMate"
              @select="clickSelect"
              is-import
            />
          </div>
        </template>
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
import { MateType } from "@/enums/mateEnums";
import api from "@/modules/api";
import { showLoadingToast } from "vant";
import { computed, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";

defineProps<{
  show: boolean;
  activeMate: Mate;
}>();

const { t } = useI18n();
const router = useRouter();
const mateStore = useMate();

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
  (e: "update:active-mate", mate: Mate): void;
}>();

const myOriginal = computed(() => {
  return mateStore.list.filter((item) => item.type === MateType.Original);
});

const myFanswork = computed(() => {
  return mateStore.list.filter((item) => item.type === MateType.Fanswork);
});

const clickCreateSelf = async () => {
  const loading = showLoadingToast(t(`Message.loading`));
  const { item } = await api.createOneMate({ type: MateType.SelfAvatar });
  await mateStore.fetchSelfAvatarList();
  loading.close();
  router.push({
    name: "treeholeSelfSetting",
    query: {
      mateUuid: item.uuid,
    },
  });
};

const clickSelect = (mate: Mate) => {
  emit("update:active-mate", mate);
};

onMounted(() => {});
</script>
